module.exports = __webpack_public_path__ + "static/media/apollo-corner.97fc914f.webp";